<template>
  <div class="room-info" v-if="channel">
    <div class="ri-title" v-if="activity && activity.liveStartTime">
      <Row :gutter="20" style="width:100%">
        <Col span="20">
        <p>您的直播时间为：{{ activity.liveStartTime | moment("YYYY/MM/DD HH:mm:ss") }} ~ {{ activity.liveEndTime | moment("YYYY/MM/DD HH:mm:ss") }}，请做好直播前内容和设备的准备</p>
        </Col>
        <Col span="4" style="text-align:right;">
        <!-- 展商修改需审核 -->
        <Button type="primary" @click="changeExhibitionLive()" v-if="isExhibition">修改直播信息</Button>
        <!-- 主办修改无需审核 -->
        <Button type="primary" @click="changeHostLive()" v-else>修改直播信息</Button>
        </Col>
      </Row>
    </div>
    <div class="ri-box">
      <Row :gutter="20">
        <Col span="12">
        <div class="rib-item">
          <div class="ribi-title"><i class="line"></i>直播背景</div>
          <div class="ribi-content">
            <Row :gutter="20">
              <Col span="10">
              <div class="my-upload">
                <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index" style="margin:0;">
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="4096" :headers="formHeaders"
                  :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl" style="display: inline-block;"
                  v-show="uploadList && uploadList.length < 1">
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传图片</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              </Col>
              <Col span="14">
              <p class="tip">
                图片要求：<br />
                请上传750*422px，<br />4M以下的jpg/jpeg/png文件
              </p>
              </Col>
            </Row>
          </div>
        </div>
        </Col>
        <Col span="12">
        <div class="txt">

          <countdown :time="downTime" v-if="downTime && now > channel.startTime">
            <template slot-scope="props">据您的开播时间还有：{{ props.days }}天{{ props.hours }}时{{ props.minutes
            }}分{{ props.seconds }}秒</template>
          </countdown>
          <template v-else>
            直播状态：
            <span class="time" v-if="channel.watchStatus === 'live'">直播中</span>
            <span class="time" v-if="channel.watchStatus === 'playback'">回放中</span>
            <span class="time" v-if="channel.watchStatus === 'end'">已结束</span>
            <span class="time" v-if="channel.watchStatus === 'waiting'">等待中</span>
            <span class="time" v-if="channel.watchStatus === 'unStart'">未开始</span>
          </template>
        </div>
        </Col>
      </Row>
    </div>
    <!-- 设置直播时间 -->
    <editExhibitionLive :show="open" @close="open = false; openInfo = null;" :info="openInfo" />
    <editHostLive :show="hostOpen" @close="hostOpen = false; hostOpenInfo = null;" :info="hostOpenInfo" />

  </div>
</template> 

<script> 
import editHostLive from "./edit-host-live.vue";
import editExhibitionLive from "./edit-exhibition-live.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "room-info",
  components: {
    editHostLive,
    editExhibitionLive,
  },
  data () {
    return {
      open: false,
      openInfo: null,

      hostOpen: false,
      hostOpenInfo: null,

      imgName: "",
      visible: false,
      defaultList: [],
      uploadList: [],
      now: new Date().getTime(),
      watchStatus: 'wait',
    };
  },
  watch: {
    channel (val) {
      if (val && val.splashImg) {
        console.log('channel', this.channel);
        this.uploadList = [
          {
            url: val.splashImg,
            status: "finished",
            percentage: 100,
          },
        ];
      }
    },
  },
  computed: {
    ...mapGetters({
      channel: "liveModule/getChannel",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      activity: "liveModule/getActivity",
    }),
    downTime () {
      let start = this.channel ? this.channel.startTime : 0;
      let time = start > this.now ? start - this.now : 0;
      return time;
    },
    isExhibition () {
      return this.$route.query.isExhibition;
    },
    activityId () {
      return this.$route.query.activityId;
    },
    channelId () {
      return this.$route.query.channelId;
    },
  },
  methods: {
    ...mapActions({
      channelSettingUpdateSplash: 'liveModule/channelSettingUpdateSplash',
      getActById: "hostActModule/getActById",
    }),
    ...mapMutations({
      setActivity: "liveModule/setActivity",
    }),
    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 上传成功
    async handleSuccess (res, file, fileList) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        let bool = await this.channelSettingUpdateSplash({
          channelId: this.channelId,
          imgFileUrl: res.list[0],
          splashEnabled: 'Y'
        });
        if (bool && bool.code === 200 && bool.isSucceed) {
          this.$Message.success("修改成功！");
        } else {
          this.$Message.error("修改失败，请重试！");
        }
      }
    },
    // 文件格式错误
    handleFormatError (file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 上传数量
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    // 移除上传图片
    handleRemove (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 文件过大
    handleMaxSize (file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于4M的图片`);
    },
    changeExhibitionLive () {
      this.open = true;
      this.openInfo = this.activity;
    },
    changeHostLive () {
      this.hostOpen = true;
      this.hostOpenInfo = this.activity;
    },
  },
}

</script>

<style lang="scss" scoped>
.room {
  &-info {
    min-height: 242px;
    background-color: #fff;
    padding: 10px 4% 20px;

    .ri {
      &-title {
        display: flex;
        align-items: center;
        margin-bottom: 19px;
        width: 100%;

        p {
          flex: 1;
          margin-top: 10px;
        }

        &-btn {
          width: 20%;
          text-align: right;
        }
      }

      &-box {
        .rib-item {
          // height: 160px;
          background-color: #fff;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          padding: 12px 20px 0;

          .ribi {
            &-title {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #333;
              font-weight: bold;
              margin-bottom: 14px;

              .line {
                width: 4px;
                height: 14px;
                background-color: #1890ff;
                margin-right: 5px;
                display: inline-block;
              }
            }

            &-content {
              padding-bottom: 20px;

              .tip {
                font-size: 12px;
                margin-left: 5px;
                display: flex;
                height: 100px;
                align-items: center;
              }

              .info-item {
                font-size: 14px;
                color: #333;
                margin: 12px 0;

                span {
                  display: inline-block;
                  padding-left: 30px;
                  color: #1890ff;
                }

                i {
                  font-style: normal;
                  color: #999;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
